/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useRef, useEffect} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import {
  defaultCreateAppData,
  ICreateAppData,
} from '../../../../_metronic/partials/modals/create-app-stepper/IAppModels'
import {StepperComponent} from '../../../../_metronic/assets/ts/components'
import AddPropertyStep5 from '../../property/AddPropertyStep6'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import Swal from 'sweetalert2'
import AddTenantStep1 from './AddTenantStep1'
import AddTenantStep2 from './AddTenantStep2'
import AddTenantStep3 from './AddTenantStep3'
import AddTenantStep4 from './AddTenantStep4'
import AddTenantStep5 from './AddTenantStep5'
import {create_tenant, get_Subdivions} from '../Tenant_API'
import {useNavigate} from 'react-router-dom'

type PropsDataType = {
  getProperty: Promise<void>
  show: boolean
  handleClose: () => void
}
interface subdivisionsDataType {
  property_sub_unit_uuid: string
  property_unit_description: string
  property_unit_max_tenants: number
  property_unit_name: string
  property_unit_rent: string
}
const modalsRoot = document.getElementById('root-modals') || document.body

const FormatDate = (date: any) => {
  const formattedDate = date.toLocaleDateString('en-CA', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })
  return formattedDate
}

const AddComTenant = ({
  property_uuid,
  show,
  handleClose,
  getTenantsList,
  subDivisions,
  tenantAPIData,
  additionalData,
  getTenants,
}: any) => {
  const navigate = useNavigate()
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [submitBtnLoading, setSubmitBtnLoading] = useState(false)
  const [data, setData] = useState<ICreateAppData>(defaultCreateAppData)

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const updateData = (fieldsToUpdate: Partial<ICreateAppData>) => {
    const updatedData = {...data, ...fieldsToUpdate}
    setData(updatedData)
  }

  const prevStep = () => {
    if (!stepper.current) {
      return
    }
    stepper.current.goPrev()
  }

  const nextStep = () => {
    if (!stepper.current) {
      return
    }
    if (stepper.current.getCurrentStepIndex() === 1) {
      if (!checkAddPropertyStep1()) {
        return
      }
    }
    if (stepper.current.getCurrentStepIndex() === 2) {
      if (!checkAddPropertyStep2()) {
        return
      }
    }
    if (stepper.current.getCurrentStepIndex() === 3) {
      if (!checkAddPropertyStep3()) {
        return
      }
    }
    if (stepper.current.getCurrentStepIndex() === 4) {
      if (!checkAddPropertyStep4()) {
        return
      }
    }
    if (stepper.current) {
      stepper.current.goNext()
    }
  }

  const initialValues = {
    tenant_name: '',
    tenant_email_id: '',
    tenant_contact_number: '',
    business_name: '',
    business_email_id: '',
    business_contact_number: '',
    property_sub_unit_uuid: '',
    property_rent_rate: '',
    security_deposit: '',
    property_rent_due_date: '',
    rental_agreement_date: '',
    tenancy_commencement_date: '',
    tenancy_expiration_date: '',
  }

  const validationSchema = Yup.object({
    tenant_name: Yup.string()
      .matches(/^[A-Za-z0-9\s]*$/, 'Only alphanumeric characters and spaces are allowed')
      .min(3, 'Minimum 3 characters required')
      .max(50, 'Maximum 50 characters are allowed')
      .required('Tenant name is required'),
    tenant_email_id: Yup.string()
      .required('Tenant email address is required')
      .email('Wrong email format'),
    tenant_contact_number: Yup.string().required('Tenant contact number is required'),
    business_name: Yup.string()
      .matches(/^[A-Za-z0-9\s]*$/, 'Only alphanumeric characters and spaces are allowed')
      .min(3, 'Minimum 3 characters required')
      .max(50, 'Maximum 50 characters are allowed')
      .required('Business name is required'),
    business_email_id: Yup.string()
      .required('Business email address is required')
      .email('Wrong email format'),
    business_contact_number: Yup.string().required('Business contact number is required'),
    property_sub_unit_uuid: Yup.string().required('Room number is required'),
    property_rent_rate: Yup.number()
      .typeError('Rent amount must be a number')
      .integer('Rent amount must be an integer')
      .positive('Rent amount must be a positive number')
      .min(0, 'Rent amount must be greater than or equal to 0')
      .max(999999999999999, 'Rent amount must have at most 15 digits')
      .required('Rent amount is required'),
    security_deposit: Yup.number()
      .typeError('Security deposit must be a number')
      .integer('Security deposit must be an integer')
      .positive('Security deposit must be a positive number')
      .min(0, 'Security deposit must be greater than or equal to 0')
      .optional(),
    property_rent_due_date: Yup.string().required('Rent due date is required'),
    rental_agreement_date: Yup.date().required('Rental agreement date is required'),
    tenancy_commencement_date: Yup.date().required('Tenancy commencement date is required'),
    tenancy_expiration_date: Yup.date().required('Tenancy expiration date is required'),
  })

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      console.log('')
    },
  })

  useEffect(() => {
    if (tenantAPIData) {
      formik.setFieldValue('tenant_name', tenantAPIData?.full_name || '')
      formik.setFieldValue('tenant_email_id', tenantAPIData?.email || '')
      formik.setFieldValue('tenant_contact_number', tenantAPIData?.mobile_number || '')
      formik.setFieldValue('property_rent_rate', additionalData?.monthlyRent || '')
      formik.setFieldValue('security_deposit', additionalData?.depositAmount || '')
      formik.setFieldValue(
        'tenancy_commencement_date',
        new Date(additionalData.moveInDate).toISOString().split('T')[0]
      )
    }
  }, [tenantAPIData])
  console.log('first formik values', formik.values)

  async function createTenant() {
    setSubmitBtnLoading(true)
    try {
      const {data: res} = await create_tenant(
        formik.values.tenant_name,
        formik.values.tenant_email_id,
        formik.values.tenant_contact_number,
        property_uuid,
        formik.values.property_rent_rate,
        formik.values.property_rent_due_date,
        formik.values.security_deposit ? parseInt(formik.values.security_deposit, 10) : 0,
        formik.values.property_sub_unit_uuid,
        formik.values.rental_agreement_date,
        formik.values.tenancy_commencement_date,
        formik.values.tenancy_expiration_date,
        formik.values.business_name,
        formik.values.business_email_id,
        formik.values.business_contact_number
      )
      if (res.code === '200') {
        getTenantsList()
        tenantAPIData && getTenants()
        handleClose()
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
          text: res.msg_details,
          allowOutsideClick: true,
        })
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
          text: res.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    } finally {
      setSubmitBtnLoading(false)
    }
  }
  const handleSubmit = async () => {
    createTenant()
  }
  const handleGoto = (val: number) => {
    let valid: number = 0
    if (val >= 1) {
      if (!checkAddPropertyStep1()) {
        stepper?.current?.goto(1)
        checkAddPropertyStep1()
        return
      } else if (val === 1 && valid === 0) {
        stepper?.current?.goto(1)
        return
      } else {
        valid = valid + 1
      }
    }
    if (val >= 2) {
      if (!checkAddPropertyStep2()) {
        stepper?.current?.goto(2)
        checkAddPropertyStep2()
        return
      } else if (val === 2 && valid === 1) {
        stepper?.current?.goto(2)
        return
      } else {
        valid = valid + 1
      }
    }
    if (val >= 3) {
      if (!checkAddPropertyStep3()) {
        stepper?.current?.goto(3)
        checkAddPropertyStep3()
        return
      } else if (val === 3 && valid === 2) {
        stepper?.current?.goto(3)
        return
      } else {
        valid = valid + 1
      }
    }
    if (val >= 4) {
      if (!checkAddPropertyStep4()) {
        stepper?.current?.goto(4)
        checkAddPropertyStep3()
        return
      } else if (val === 4 && valid === 3) {
        stepper?.current?.goto(4)
        return
      } else {
        valid = valid + 1
      }
    }
    if (val === 5) {
      if (valid === 4) {
        stepper?.current?.goto(5)
        return
      }
    }
    return
  }
  const checkAddPropertyStep1 = () => {
    if (
      formik.values.tenant_name &&
      formik.values.tenant_email_id &&
      formik.values.tenant_contact_number &&
      !formik.errors.tenant_name &&
      !formik.errors.tenant_email_id &&
      !formik.errors.tenant_contact_number
    ) {
      return true
    } else {
      formik.setTouched(
        {
          tenant_name: true,
          tenant_email_id: true,
          tenant_contact_number: true,
        },
        true
      )
      return false
    }
  }
  const checkAddPropertyStep2 = () => {
    if (
      formik.values.business_name &&
      formik.values.business_email_id &&
      formik.values.business_contact_number &&
      !formik.errors.business_name &&
      !formik.errors.business_email_id &&
      !formik.errors.business_contact_number
    ) {
      return true
    } else {
      formik.setTouched(
        {
          business_name: true,
          business_email_id: true,
          business_contact_number: true,
        },
        true
      )
      return false
    }
  }
  const checkAddPropertyStep3 = () => {
    if (subDivisions.length > 0) {
      if (
        formik.values.property_sub_unit_uuid &&
        formik.values.property_rent_rate &&
        !formik.errors.property_sub_unit_uuid &&
        !formik.errors.property_rent_rate &&
        !formik.errors.security_deposit
      ) {
        return true
      } else {
        formik.setTouched(
          {
            property_sub_unit_uuid: true,
            property_rent_rate: true,
            security_deposit: true,
          },
          true
        )
        return false
      }
    } else if (
      formik.values.property_rent_rate &&
      !formik.errors.property_rent_rate &&
      !formik.errors.security_deposit
    ) {
      return true
    } else {
      formik.setTouched(
        {
          property_rent_rate: true,
          security_deposit: true,
        },
        true
      )
      return false
    }
  }
  const checkAddPropertyStep4 = () => {
    if (
      formik.values.property_rent_due_date &&
      formik.values.rental_agreement_date &&
      formik.values.tenancy_commencement_date &&
      formik.values.tenancy_expiration_date &&
      !formik.errors.property_rent_due_date &&
      !formik.errors.rental_agreement_date &&
      !formik.errors.tenancy_commencement_date &&
      !formik.errors.tenancy_expiration_date
    ) {
      return true
    } else {
      formik.setTouched(
        {
          property_rent_due_date: true,
          rental_agreement_date: true,
          tenancy_commencement_date: true,
          tenancy_expiration_date: true,
        },
        true
      )
      return false
    }
  }
  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-900px'
      show={show}
      onHide={handleClose}
      onEntered={loadStepper}
      backdrop={true}
    >
      <div className='modal-header pt-5 pb-5'>
        {/* begin::Heading */}
        <h2>Add Commercial Tenant</h2>
        {/* end::Heading */}
        {/* begin::Close */}
        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
          <i className='bi bi-x-lg' onClick={handleClose}></i>
        </div>
        {/* end::Close */}
      </div>

      <div className='modal-body p-5'>
        {/*begin::Stepper */}
        <div
          ref={stepperRef}
          className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid'
          id='kt_modal_create_app_stepper'
        >
          {/* begin::Aside*/}
          <div className='d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px'>
            {/* begin::Nav*/}
            <div className='stepper-nav ps-lg-10 py-4'>
              {/* begin::Step 1*/}
              <div className='stepper-item current' data-kt-stepper-element='nav'>
                {/* begin::Wrapper*/}
                <div className='stepper-wrapper cursor-pointer' onClick={() => handleGoto(1)}>
                  {/* begin::Icon*/}
                  <div className='stepper-icon w-40px h-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>1</span>
                  </div>
                  {/* end::Icon*/}

                  {/* begin::Label*/}
                  <div className='stepper-label'>
                    <h3 className='stepper-title'>Tenant Details</h3>

                    <div className='stepper-desc'>Enter tenant details</div>
                  </div>
                  {/* end::Label*/}
                </div>
                {/* end::Wrapper*/}

                {/* begin::Line*/}
                <div className='stepper-line h-40px'></div>
                {/* end::Line*/}
              </div>
              {/* end::Step 1*/}

              {/* begin::Step 2*/}
              <div className='stepper-item' data-kt-stepper-element='nav'>
                {/* begin::Wrapper*/}
                <div className='stepper-wrapper cursor-pointer' onClick={() => handleGoto(2)}>
                  {/* begin::Icon*/}
                  <div className='stepper-icon w-40px h-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>2</span>
                  </div>
                  {/* begin::Icon*/}

                  {/* begin::Label*/}
                  <div className='stepper-label'>
                    <h3 className='stepper-title'>Business Contact Details</h3>

                    <div className='stepper-desc'>Enter Business contact details</div>
                  </div>
                  {/* begin::Label*/}
                </div>
                {/* end::Wrapper*/}

                {/* begin::Line*/}
                <div className='stepper-line h-40px'></div>
                {/* end::Line*/}
              </div>
              {/* end::Step 2*/}

              {/* begin::Step 3*/}
              <div className='stepper-item' data-kt-stepper-element='nav'>
                {/* begin::Wrapper*/}
                <div className='stepper-wrapper cursor-pointer' onClick={() => handleGoto(3)}>
                  {/* begin::Icon*/}
                  <div className='stepper-icon w-40px h-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>3</span>
                  </div>
                  {/* end::Icon*/}

                  {/* begin::Label*/}
                  <div className='stepper-label'>
                    <h3 className='stepper-title'>Property & Rent</h3>

                    <div className='stepper-desc'>Enter property & rent details</div>
                  </div>
                  {/* end::Label*/}
                </div>
                {/* end::Wrapper*/}

                {/* begin::Line*/}
                <div className='stepper-line h-40px'></div>
                {/* end::Line*/}
              </div>
              {/* end::Step 3*/}

              {/* begin::Step 4*/}
              <div className='stepper-item' data-kt-stepper-element='nav'>
                {/* begin::Wrapper*/}
                <div className='stepper-wrapper cursor-pointer' onClick={() => handleGoto(4)}>
                  {/* begin::Icon*/}
                  <div className='stepper-icon w-40px h-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>4</span>
                  </div>
                  {/* end::Icon*/}

                  {/* begin::Label*/}
                  <div className='stepper-label'>
                    <h3 className='stepper-title'>Agreement</h3>

                    <div className='stepper-desc'>Enter agreement details</div>
                  </div>
                  {/* end::Label*/}
                </div>
                {/* end::Wrapper*/}

                {/* begin::Line*/}
                <div className='stepper-line h-40px'></div>
                {/* end::Line*/}
              </div>
              {/* end::Step 4*/}

              {/* begin::Step 5*/}
              <div className='stepper-item' data-kt-stepper-element='nav'>
                {/* begin::Wrapper*/}
                <div className='stepper-wrapper cursor-pointer' onClick={() => handleGoto(5)}>
                  {/* begin::Icon*/}
                  <div className='stepper-icon w-40px h-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>5</span>
                  </div>
                  {/* end::Icon*/}

                  {/* begin::Label*/}
                  <div className='stepper-label'>
                    <h3 className='stepper-title'>Review</h3>

                    <div className='stepper-desc'>Review and Submit</div>
                  </div>
                  {/* end::Label*/}
                </div>
                {/* end::Wrapper*/}
              </div>
              {/* end::Step 5*/}
            </div>
            {/* end::Nav*/}
          </div>
          {/* begin::Aside*/}

          {/*begin::Content */}
          <div className='flex-row-fluid px-lg-15'>
            {/*begin::Form */}
            <form onSubmit={formik.handleSubmit} id='kt_modal_create_app_form'>
              <AddTenantStep1 formik={formik} />
              <AddTenantStep2 formik={formik} />
              <AddTenantStep3 formik={formik} subDivisions={subDivisions} />
              <AddTenantStep4 formik={formik} />
              <AddTenantStep5 />
              {/*begin::Actions */}
              <div className='d-flex flex-stack pt-4'>
                <div className='me-2'>
                  <button
                    type='button'
                    className='btn btn-lg btn-light-primary me-3'
                    data-kt-stepper-action='previous'
                    onClick={prevStep}
                  >
                    {/* <KTSVG
                      path='/media/icons/duotune/arrows/arr063.svg'
                      className='svg-icon-3 me-1'
                    />{' '} */}
                    Previous
                  </button>
                </div>
                <div>
                  <button
                    type='submit'
                    className='btn btn-lg btn-primary'
                    data-kt-stepper-action='submit'
                    onClick={handleSubmit}
                    disabled={submitBtnLoading}
                  >
                    {submitBtnLoading ? (
                      <span className='indicator-progress' style={{display: 'block'}}>
                        Processing...
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    ) : (
                      'Submit'
                    )}

                    {/* <KTSVG
                      path='/media/icons/duotune/arrows/arr064.svg'
                      className='svg-icon-3 ms-2 me-0'
                    /> */}
                  </button>

                  <button
                    type='button'
                    className='btn btn-lg btn-primary'
                    data-kt-stepper-action='next'
                    onClick={nextStep}
                  >
                    Next Step{' '}
                    {/* <KTSVG
                      path='/media/icons/duotune/arrows/arr064.svg'
                      className='svg-icon-3 ms-1 me-0'
                    /> */}
                  </button>
                </div>
              </div>
              {/*end::Actions */}
            </form>
            {/*end::Form */}
          </div>
          {/*end::Content */}
        </div>
        {/* end::Stepper */}
      </div>
    </Modal>,
    modalsRoot
  )
}

export default AddComTenant
